module.exports = __webpack_public_path__ + "static/media/logopng.db1db614.jpg";